import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';
import { cleanupLinks, quillModules } from './Utils';

const StyledReactQuill = styled(ReactQuill)`

    white-space: pre-wrap;

    .ql-tooltip {
        z-index: 99;
    }

    .ql-header {
        border: 1px solid #ccc;
    }
`

const CustomEditor = ({ value, onChange }) => {
    return (
        <StyledReactQuill
            theme="snow"
            value={value}
            onChange={(value) => onChange(cleanupLinks(value))}
            modules={quillModules}
        />
    );
}

export default CustomEditor;